import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { CognitoService } from "src/app/services/cognito.service";
import { DocumentsService } from "src/app/services/document.service";
import { environment } from "src/environments/environment";
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { v4 as uuidv4 } from 'uuid';
import Swal from "sweetalert2";
import {UtilsService} from "../../../services/utils.service";
import {NotificationsService} from "../../../services/notifications.service";
import * as XLSX from 'xlsx'; // Importa la librería xlsx
declare var $: any;

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrl: './clientes.component.css'
})
export class ClientesComponent implements OnInit{

  dataTable: any;
  userData: any;              //Datos del usuario logueado

  programaSeleccionado: any;  //Programa seleccionado para inscripcion
  detallePeriodos: any = [];  //Detalle de los periodos del programa seleccionado
  fechasProximosLunes: string[] = [];
  fechaInicioSeleccionada: any = ''; //Fecha de inicio seleccionada para inscripcion
  clienteSeleccionado: any;   //Cliente seleccionado para inscripcion
  clientes: any;              //Arreglo de clientes completo
  mostrarClientes: any = [];  //Arreglo de clientes para mostrar en la tabla si se filtran
  clienteAMostrar: any;       //Cliente seleccionado para mostrar su informacion en modal
  
  //Lista de programas
  listaProgramas: any = [];
  filtersPrograma: any = {
    tipo: "1"
  };

  diaNacimiento = this.utilService.days();
  mesNacimiento = this.utilService.months();
  anoNacimiento = this.utilService.years();

  FormClient: FormGroup;

  constructor(
    private fb: FormBuilder,
    private documentService: DocumentsService,
    private cognitoService: CognitoService,
    private sanitizer: DomSanitizer,
    private utilService: UtilsService,
    private notificationsService: NotificationsService
  )
  {
    this.FormClient = this.fb.group({
      nombre: ["", [Validators.required]],
      sexo: ["", [Validators.required]],
      fechaNacimientoSeparada: this.fb.group({
        dia: ['', [Validators.required]],
        mes: ['', [Validators.required]],
        anio: ['', [Validators.required]]
      }),
      fechaNacimiento: [""],
      email: ["", [Validators.required, Validators.email]],
      // password: ['', [Validators.required,  Validators.minLength(6), this.passwordValidator]],
      // confirmPassword: ['', [Validators.required]],
      lada: [{value:'+52', disabled: false}, [Validators.pattern("^[0-9+]*$")]],
      telefono: [{value:'', disabled:false}, [Validators.pattern("^[0-9]*$"), Validators.minLength(10)]],
    }, {} );

  }

  ngOnInit(): void {
    $('#sidebar-overlay').click();
    this.userData = JSON.parse(localStorage.getItem("userData"));
    console.log(this.userData);
    this.getClients();
    // this.getProgramas();
    this.filterProgramas();
  }

  inicializarDataTable()
  {
    if (this.dataTable) {
      this.dataTable.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTable = $('#dataTable-listaClientes').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        order: [[0, 'asc']],
      });
    });
  }
  encodeURIComponent(value: string): string {
    return encodeURIComponent(value);
  }

  //METODOS CRUD CLIENTE-----------------------------------------
  createClient() {
    
    console.log('Cliente:', this.FormClient);

    let masterData = JSON.parse(localStorage.getItem('userData'));

    let masterClientContainerId = masterData.documentContainerId;

    let pass = this.utilService.create_UUID()
    pass = pass.substr(0,7) + "a."

    console.log('password generico', pass)

    let clientModel = {
      nombre: this.FormClient.value.nombre,
      sexo: this.FormClient.value.sexo,
      fechaNacimiento: this.FormClient.value.fechaNacimiento,
      email: this.FormClient.value.email,
      telefono: this.FormClient.value.telefono.length>7 ? this.FormClient.value.lada + this.FormClient.value.telefono : '',
      password: pass,
      estatus: true, //CHECAR ESTE ESTATUS\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
      cuestionario: "nuevo", //SIEMPRE VA A SER NUEVO\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
      expediente: {programas:[]},//ARREGLO EN BLANCO LLAMADO "programas"
      idEmpresa: masterClientContainerId,
      propietario: masterData.empresaId,
      rol: 'cliente',
    }


    // DAR DE ALTA AL CLIENTE
    this.cognitoService.signUp(
      clientModel.email,
      clientModel.email,
      clientModel.password,
      clientModel.telefono,
      'cliente',
      masterClientContainerId
    ).then((response) => {
      console.log(response);
      //DESPUES DE DAR DE ALTA AL CLIENTE, SE GUARDA EL CLIENTE EN LA LISTA DE CLIENTES DE LA BASE DE DATOS
      this.documentService.createDocumentInContainer(
          environment.businessId, //un string equis
          masterClientContainerId, //correo
          clientModel.email+'Cliente',
          'cliente',
          null,
          clientModel
      ).subscribe({
        next: (response: any) => {
          $("#modal-nuevoCliente").modal("hide");
          this.clientes.push(response);
          this.inicializarDataTable();

          /**** Envío de Email  ****/
          const subject = "Se realizó tu registro a la plataforma 180 fitness";

          const body = `Hola, se realizó el registro de tu usuario para nuestra plataforma 180 fitness. Puedes ingresar utilizando el nombre de usuario ${this.FormClient.value.email} y contraseña ${pass}`;

          this.notificationsService.sendEmail(subject, body, this.FormClient.value.email).subscribe({
            next: (data) => {

              Swal.fire({
                title: "Cliente creado",
                text: "El cliente ha sido creado correctamente. Se le enviará un correo para confirmar su cuenta.",
                icon: "success",
              })
            },
            error: (error) => {
              console.log(error);
              Swal.fire({
                title: "Error al enviar correo",
                text: "Error al enviar correo.",
                icon: "error",
              })
            },
          });

        },
        error: (error) => {
          console.log(error);
          // REMOVE IF COGNITO FAILS
          this.clientes
        },
        complete: () => {
          this.FormClient.reset();
        }
      })
    }).catch((error) => {
      console.log(error);
      if(error.code == 'UsernameExistsException') {
        Swal.fire({
          title: "Error al crear cliente",
          text: "El correo ya se encuentra registrado.",
          icon: "error",
        })
      }
    }).finally(() => {

    })

  }
  disabledBtnInscripcion(): boolean
  {
    return !this.clienteSeleccionado || !this.programaSeleccionado || !this.fechaInicioSeleccionada;
  }
  inscribirClienteAPrograma()
  {
    // console.log('clienteSeleccionado', this.clienteSeleccionado);
    console.log('programaSeleccionado', this.programaSeleccionado)
    if(this.programaSeleccionado.tipo == '2') {
      if(!this.programaSeleccionado.periodos[0].rutinasPorDia) {
        Swal.fire({
          title: "Programa no configurado",
          text: "No es posible inscribir el cliente a este programa. Este programa aún no cuenta con rutinas configuradas en el calendario.",
          icon: "error",
        })
        return;
      }
    } 

    // copia del array programas que tiene el cliente
    let programas = this.clienteSeleccionado.expediente.programas ? this.clienteSeleccionado.expediente.programas : [];
    let diasXPeriodo: any = [];
    let configuracionMacrosXdia: any = [];
    let fechaInicio = new Date(this.fechaInicioSeleccionada);

    // Calcula fechas inicio y fin por periodo
    let fechaXPeriodo = new Date(this.fechaInicioSeleccionada);
    let periodos: any = [];
    let numDia: number = 0;
    for(let i_periodo=1; i_periodo<this.programaSeleccionado.cantPeriodos+1; i_periodo++) {
      let fechaInicioPeriodo: Date = new Date(fechaXPeriodo);
      fechaInicioPeriodo.setHours(0, 0, 0, 0)
      fechaXPeriodo.setDate(fechaXPeriodo.getDate() + ((7*this.programaSeleccionado.cantSemanas)-1)); // Incrementar la fecha para el siguiente periodo
      let fechaFinPeriodo: Date = new Date(fechaXPeriodo);
      fechaFinPeriodo.setHours(23, 59, 59, 999)
      periodos.push({
        periodo: i_periodo,
        fechaInicio: this.formatearFecha(new Date(fechaInicioPeriodo)),
        fechaFin: this.formatearFecha(new Date(fechaXPeriodo)),
        fechaInicioDate: fechaInicioPeriodo.toISOString(),
        fechaFinDate: fechaFinPeriodo.toISOString()
      });
      fechaXPeriodo.setDate(fechaXPeriodo.getDate() + 1); // Incrementar la fecha para el siguiente periodo

      // Genera array de diasXPeriodo y configuracionMacrosXdia
      for(let i_semana=1; i_semana<this.programaSeleccionado.cantSemanas+1; i_semana++) {
        for(let i_diaSemana=1; i_diaSemana<=7; i_diaSemana++) {
          numDia++;
          let dia = {
            dia: numDia,
            periodo: i_periodo,
            fecha: this.formatearFecha(new Date(fechaInicio)) // Asignar la fecha de inicio formateada
          }
          diasXPeriodo.push(dia);
          let configMacro = {
            dia: numDia,
            periodo: i_periodo,
            fecha: this.formatearFecha(new Date(fechaInicio)), // Asignar la fecha de inicio formateada
            "calorias": 0,
            "carbsGramos": 0,
            "carbsPorcentaje": 0,
            "proteGramos": 0,
            "protePorcentaje": 0,
            "grasaGramos": 0,
            "grasaPorcentaje": 0
          }
          configuracionMacrosXdia.push(configMacro);
          fechaInicio.setDate(fechaInicio.getDate() + 1); // Incrementar la fecha para la siguiente rutina
        }
      }
    }

    // Agregar el programa al expediente del cliente
    programas.push({
      activo: true,
      configuracionPrograma: {
        id: this.programaSeleccionado.documentId,
        tipo: this.programaSeleccionado.tipo,
        nombre: this.programaSeleccionado.nombre,
        entrenador: this.programaSeleccionado.entrenador,
        cantSemanas: this.programaSeleccionado.cantSemanas,
        cantPeriodos: this.programaSeleccionado.cantPeriodos
      },
      alimentacion: [],
      progreso: [],
      periodos: periodos,
      diasXPeriodo: diasXPeriodo,
      configuracionMacrosXdia: configuracionMacrosXdia
    });
    let clienteDocumentModel = {
      expediente: {
        programas: programas
      }
    }
    // console.log('clienteDocumentModel', clienteDocumentModel);

    // Actualizar el expediente del cliente
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userData.documentContainerId,
      this.clienteSeleccionado.documentId,
      'cliente',
      null,
      clienteDocumentModel
    ).subscribe({
      next: (data: any) => {
        console.log(data);
        $("#modal-inscripcion").modal("hide");
        this.getClients();
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        this.inicializarModalInscripcion();
        Swal.fire({
          title: "Inscripción exitosa",
          text: "El cliente ha sido inscrito al programa correctamente.",
          icon: "success",
        })
      }
    })
  }
  // Método para formatear la fecha en dd-mm-aaaa
  formatearFecha(fecha: Date): string {
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const anio = fecha.getFullYear();
    return `${dia}-${mes}-${anio}`;
  }
  getProgramaActualySiguiente(cliente: any): { programaActivo: any, siguientePrograma: any } {
    let programaActivo = null;
    let siguientePrograma = null;
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0); // Normalizar la fecha actual

    if(cliente.expediente?.programas.length == 0) return {programaActivo, siguientePrograma}; // Si no tiene programas, retornar null

    cliente.expediente?.programas.forEach((programa: any) => {
      const fechaInicio = new Date(programa.periodos[0].fechaInicioDate);
      fechaInicio.setHours(0, 0, 0, 0); // Normalizar la fecha de inicio
      const fechaFin = new Date(programa.periodos[programa.periodos.length - 1].fechaFinDate);
      fechaFin.setHours(23, 59, 59, 999); // Normalizar la fecha de fin
      if (hoy >= fechaInicio && hoy <= fechaFin) {
        programaActivo = programa;
        const siguienteProgramaIndex = cliente.expediente.programas.indexOf(programa) + 1;
        if (siguienteProgramaIndex < cliente.expediente.programas.length) {
          siguientePrograma = cliente.expediente.programas[siguienteProgramaIndex];
        }
      }
    });
    if(programaActivo == null && new Date(cliente.expediente.programas[0].periodos[0].fechaInicioDate) > hoy) {
      siguientePrograma = cliente.expediente.programas[0];
    }
    return {programaActivo, siguientePrograma};
  }
  getPeriodosActuales(cliente: any): { periodoActual: any, siguientePeriodo: any, fechaFinalPrograma: any } {
    // console.log('cliente', cliente);
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    let periodoActual = null;
    let siguientePeriodo = null;
    let fechaFinalPrograma = null;

    for (let i = 0; i < cliente.expediente.programas.length; i++) {
      const programa = cliente.expediente.programas[i];
      for (let j = 0; j < programa.periodos.length; j++) {
        const periodo = programa.periodos[j];
        // const fechaInicio = new Date(periodo.fechaInicio.split('-').reverse().join('-'));
        // const fechaFin = new Date(periodo.fechaFin.split('-').reverse().join('-'));
        const fechaInicio = new Date(periodo.fechaInicioDate);
        const fechaFin = new Date(periodo.fechaFinDate);
        // Normalizar las fechas para comparar solo día/mes/año
        fechaInicio.setHours(0, 0, 0, 0);
        fechaFin.setHours(23, 59, 59, 999);

        if (hoy >= fechaInicio && hoy <= fechaFin) {
          fechaFinalPrograma = new Date(programa.periodos[programa.periodos.length-1].fechaFinDate);
          periodoActual = {
            ...periodo,
            fechaInicio: this.formatearFechaPeriodo(fechaInicio),
            fechaFin: this.formatearFechaPeriodo(fechaFin),
            fechaInicioDate: fechaInicio,
            fechaFinDate: fechaFin

          };
          if (j + 1 < programa.periodos.length) {
            const siguiente = programa.periodos[j + 1];
            const siguienteFechaInicio = new Date(siguiente.fechaInicioDate);
            const siguienteFechaFin = new Date(siguiente.fechaFinDate);
            siguientePeriodo = {
              ...siguiente,
              // fechaInicio: this.formatearFechaPeriodo(new Date(siguiente.fechaInicio.split('-').reverse().join('-'))),
              // fechaFin: this.formatearFechaPeriodo(new Date(siguiente.fechaFin.split('-').reverse().join('-')))
              fechaInicio: this.formatearFechaPeriodo(siguienteFechaInicio),
              fechaFin: this.formatearFechaPeriodo(siguienteFechaFin),
              fechaInicioDate: siguienteFechaInicio,
              fechaFinDate: siguienteFechaFin,
              nombreSiguientePrograma: programa.configuracionPrograma.nombre
            };
          }
          break;
        } else if (hoy < fechaInicio && !siguientePeriodo) {
          siguientePeriodo = {
            ...periodo,
            fechaInicio: this.formatearFechaPeriodo(fechaInicio),
            fechaFin: this.formatearFechaPeriodo(fechaFin),
            fechaInicioDate: fechaInicio,
            fechaFinDate: fechaFin,
            nombreSiguientePrograma: programa.configuracionPrograma.nombre
          };
        }
      }
      if (periodoActual) break;
    }
    // console.log('periodoActual', periodoActual);
    // console.log('siguientePeriodo', siguientePeriodo);
    return { periodoActual, siguientePeriodo, fechaFinalPrograma };
  }
  calcularDiasRestantes(fechaFin: string): number {
    // console.log('===> fechaFin', fechaFin);
    const hoy = new Date();
    // const fechaFinDate = new Date(fechaFin.split('-').reverse().join('-'));
    const fechaFinDate = new Date(fechaFin);
    // console.log('fechaFinDate', fechaFinDate);

    const diferenciaTiempo = fechaFinDate.getTime() - hoy.getTime();
    const diferenciaDias = Math.ceil(diferenciaTiempo / (1000 * 3600 * 24));
    return diferenciaDias;
  }
  // Método para formatear la fecha en formato "6 ene. 2025"
  formatearFechaPeriodo(fecha: Date): string {
    return fecha.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
  }
  

  //OJO QUE CREO QUE VA A HABER UN BUG CUANDO SI SE CREA UN CLIENTE MIENTRAS SE ESTA FILTRANDO
  getClients()
  {
    let masterData = JSON.parse(localStorage.getItem('userData'));

    let masterTrainerContainerId = masterData.documentContainerId;

    this.documentService.getDocumentsByType(
      environment.businessId,
      masterTrainerContainerId,
      'cliente'
    ).subscribe({
      next: (response: any) => {
        this.clientes = response.content;
        this.mostrarClientes = this.clientes;
        console.log(this.mostrarClientes);
        for(let i=0; i<this.clientes.length; i++) {
          const { programaActivo, siguientePrograma } = this.getProgramaActualySiguiente(this.clientes[i]);
          this.clientes[i].programaActivo = programaActivo;
          this.clientes[i].siguientePrograma = siguientePrograma;
          const { periodoActual, siguientePeriodo, fechaFinalPrograma } = this.getPeriodosActuales(this.clientes[i]);
          this.clientes[i].periodoActual = periodoActual;
          this.clientes[i].siguientePeriodo = siguientePeriodo;
          this.clientes[i].fechaFinalPrograma = fechaFinalPrograma;
          this.clientes[i].diasRestantes = this.calcularDiasRestantes(fechaFinalPrograma);
          if(i == this.clientes.length - 1) {
            this.inicializarDataTable();
          }
        }
        console.log('clientes', this.clientes);
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
      }
    })
  }

  //----------------------------- INSCRIBIR A PROGRAMA --------------------------------
  getProgramas() {
    this.documentService.getDocumentsByType(
      environment.businessId,
      this.userData.documentContainerId,
      "programa"
    ).subscribe({
      next: (data: any) => {
        console.log(data);
        this.listaProgramas = data.content;
        this.inicializarDataTableProgramas();
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        console.log(this.listaProgramas)
      }
    })
  }
  filterProgramas() {
    const filters: any = {
      "documentContainerId": this.userData.documentContainerId,
      // "empresaId": this.userInfo.empresaId,
      // "activo": true
    };
    // GET FILTERS ARRAY
    let query: any = this.documentService.getFiltersArray(filters);
    if(this.filtersPrograma.tipo != '') {
      query.push({
        "match_phrase": {
          "tipo.keyword": this.filtersPrograma.tipo
        }
      });
    }
    console.log(query);

    const esQuery = {
      "from": 0,
      "size": 1000,
      "query": {
        "bool": {
          "must": [],
          "filter": query,
          "should": [],
          "must_not": []
        }
      },
    }

    this.documentService.searchDocument(
      environment.businessId,
      "programa",
      esQuery
    ).subscribe({
      next: (data: any) => {
        this.listaProgramas = data;
        this.inicializarDataTableProgramas();
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        console.log(this.listaProgramas)}
    })
  }
  dataTableProgramas: any;
  inicializarDataTableProgramas()
  {
    if (this.dataTableProgramas) {
      this.dataTableProgramas.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableProgramas = $('#dataTable-listaProgramas').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No se encontraron resultados"
        },
        pageLength: 10,
      });
    });
  }
  
  modalInscripcion(cliente: any, programaActivo: any)
  {
    let hoy: Date;
    if(programaActivo) {
      hoy = new Date(programaActivo.periodos[programaActivo.periodos.length-1].fechaFinDate);
      hoy.setDate(hoy.getDate() + 1);
    } else {
      hoy = new Date();
    }
    hoy.setHours(0, 0, 0, 0);
    this.calcularProximosLunes(hoy);
    this.clienteSeleccionado = cliente;
    console.log('cliente', this.clienteSeleccionado)
    $("#modal-inscripcion").modal({ backdrop: "static", keyboard: false });
    $("#modal-inscripcion").modal("show");
  }
  inicializarModalInscripcion() {
    this.programaSeleccionado = null;
    this.detallePeriodos = [];
    this.fechaInicioSeleccionada = '';
    this.clienteSeleccionado = null;
    this.fechasProximosLunes = [];
    this.filtersPrograma.tipo = '1'
    this.filterProgramas();
  }
  seleccionarPrograma(programa) {
    this.programaSeleccionado = programa;
    console.log('programa', this.programaSeleccionado)
    if(this.fechaInicioSeleccionada) this.calcularPeriodos();
  }
  calcularProximosLunes(hoy: Date): void {
    const proximosLunes = [];
    
    // Calcular los próximos 3 lunes
    let lunes = new Date(hoy.setDate(hoy.getDate() + (1 + 7 - hoy.getDay()) % 7));
    for (let i = 0; i < 3; i++) {
      // proximosLunes.push(new Date(lunes));
      proximosLunes.push({
        value: new Date(lunes),
        fecha: lunes.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
      });
      lunes.setDate(lunes.getDate() + 7);
    }

    // ********************************************************************************************************************
    // Funcionalidad para hacer pruebas y poder asignar programas de días anteriores
    // Calcular los 20 lunes anteriores
    /* const lunesAnteriores = [];
    lunes = new Date(hoy.setDate(hoy.getDate() - (hoy.getDay() + 6) % 7)); // Último lunes
    for (let i = 0; i < 20; i++) {
      lunesAnteriores.push({
          value: new Date(lunes),
          fecha: lunes.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
      });
      lunes.setDate(lunes.getDate() - 7);
    }
    // Combinar los lunes anteriores y los próximos lunes
    this.fechasProximosLunes = [...lunesAnteriores.reverse(), ...proximosLunes];*/
    // ********************************************************************************************************************
    
    // this.fechasProximosLunes = proximosLunes.map(fecha => fecha.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }));
    this.fechasProximosLunes = proximosLunes
    console.log('fechasProximosLunes', this.fechasProximosLunes)
  }
  calcularPeriodos() {
    this.detallePeriodos = [];
    let fechaInicio = new Date(this.fechaInicioSeleccionada);
    for (let i = 0; i < this.programaSeleccionado.cantPeriodos; i++) {
      this.detallePeriodos.push({
        fechaInicio: new Date(fechaInicio),
        fechaFin: new Date(fechaInicio.setDate(fechaInicio.getDate() + (7 * this.programaSeleccionado.cantSemanas) - 1))
      });
      fechaInicio.setDate(fechaInicio.getDate() + 1);
    }
    // console.log('detallePeriodos', this.detallePeriodos)
  }

  modalNuevoCliente()
  {
    this.iniciarlizarFormCliente();
    $("#modal-nuevoCliente").modal({ backdrop: "static", keyboard: false });
    $("#modal-nuevoCliente").modal("show");
  }

  //Metodo para filtrar por nombre
  filter(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.mostrarClientes = this.clientes.filter(cliente =>
      cliente.nombre.toLowerCase().includes(inputValue.toLowerCase())
    );
  }

  //EXTRAS---------------------------------------------------------------------------
  passwordValidator(control: any): { [key: string]: boolean } | null {
    const password = control.value || '';
    const hasNumber = /\d/.test(password);
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);

    if (!hasNumber || !hasUpperCase || !hasLowerCase) {
    return { invalidPassword: true };
    }
    return null;
  }

  abrirCalendario(input: HTMLInputElement): void {
    input.showPicker(); // Activa el selector de fecha
  }

  checkPasswords(group: FormGroup) {
    let pass = group.get('password')?.value;
    let confirmPass = group.get('confirmPassword')?.value;

    return pass === confirmPass ? null : { passwordsDoNotMatch: true }
  }

  printFecha(){
    if (this.FormClient.get('fechaNacimientoSeparada.anio')?.value && this.FormClient.get('fechaNacimientoSeparada.mes')?.value && this.FormClient.get('fechaNacimientoSeparada.dia')?.value) {
      const fecha = `${this.FormClient.get('fechaNacimientoSeparada.anio')?.value}-${this.FormClient.get('fechaNacimientoSeparada.mes')?.value}-${this.FormClient.get('fechaNacimientoSeparada.dia')?.value.padStart(2, '0')}`;
        this.FormClient.get('fechaNacimiento')?.setValue(fecha); 
        console.log(fecha);
    }
  }

  iniciarlizarFormCliente(){
    this.FormClient.patchValue({
      nombre: '',
      sexo: '',
      fechaNacimiento: '',
      fechaNacimientoSeparada: {
        dia: null,
        mes: null,
        anio: null
      },
      email: '',
      password: '',
      confirmPassword: '',
      telefono: ''
    })
  }

  showModalCliente(cliente)
  {
    this.clienteAMostrar = cliente;
    $("#modal-infoCliente").modal("show");
  }

  exportarExcel(): void {
        
    const datos = this.mostrarClientes.map(cliente => ({
      Cliente: cliente.nombre,
      "Programa Activo": cliente.programaActivo ? cliente.programaActivo.configuracionPrograma.nombre : "Sin programa",
      "Entrenador": cliente.programaActivo ? cliente.programaActivo.configuracionPrograma.entrenador : "-",
      "Periodo Actual": cliente.periodoActual ? 
        `${this.formatFecha(cliente.periodoActual.fechaInicioDate)} - ${this.formatFecha(cliente.periodoActual.fechaFinDate)}` : "Sin periodo",
      "Siguiente Periodo": cliente.siguientePeriodo ? 
        `${this.formatFecha(cliente.siguientePeriodo.fechaInicioDate)} - ${this.formatFecha(cliente.siguientePeriodo.fechaFinDate)}` : "No asignado",
      "Días Restantes": ((cliente.diasRestantes !== undefined ) && (cliente.diasRestantes > 0)) ? cliente.diasRestantes : "-"
    }));

    
    const worksheet = XLSX.utils.json_to_sheet(datos);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Clientes");

    XLSX.writeFile(workbook, `Lista_Clientes_${new Date().toISOString().slice(0, 10)}.xlsx`);

  }
  private formatFecha(fecha: string): string {
    return new Date(fecha).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
  }
  
}